export default __webpack_public_path__ + "static/media/download.94557526.svg";